import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeColorCodesPipe', standalone: true })
export class removeColorCodesPipe implements PipeTransform {
    transform(tournamentName: string) {
        let regexp = new RegExp(/{#[a-zA-Z0-9]{1}}/g);
        return tournamentName.replace(regexp, '');
    }
}
